module.exports = __webpack_public_path__ + "img/pin-location.761d9403.png";